import { TriangleAlert } from 'lucide-react';
import React from 'react';
import { useAutomationEditorContext } from '../AutomationEditorContext';
import { useSegmentDefinitions } from '../useSegmentDefinitions';
import {
  describeSegmentReuseProblem,
  getTemplateSegmentUsage,
  type SegmentUsage,
} from './segment-usage';
import { UNNAMED_SEGMENT_LABEL } from './segment-picker-copy';
import styles from './SegmentPicker.module.css';

interface SegmentReuseNoticeProps {
  isUsageOnThisStep: (usage: SegmentUsage) => boolean;
}

export const SegmentReuseNotice: React.FC<SegmentReuseNoticeProps> = ({ isUsageOnThisStep }) => {
  const { editor } = useAutomationEditorContext();
  const { data: segmentDefinitions } = useSegmentDefinitions();
  const usage = getTemplateSegmentUsage(editor.state.localContents);

  const reuseWarnings = [...usage].flatMap(([segmentId, usages]) => {
    const isUsedOnThisStep = usages.some(isUsageOnThisStep);
    if (!isUsedOnThisStep) return [];
    const segmentName =
      segmentDefinitions?.find(segment => segment.canonicalVersionId === segmentId)?.name ??
      UNNAMED_SEGMENT_LABEL;
    const warning = describeSegmentReuseProblem(segmentName, usages);
    return warning ? [{ segmentId, warning }] : [];
  });

  return (
    <>
      {reuseWarnings.map(({ segmentId, warning }) => (
        <p key={segmentId} role="alert" className={styles.reuseWarning}>
          <TriangleAlert aria-hidden="true" />
          {warning}
        </p>
      ))}
    </>
  );
};
